// extracted by mini-css-extract-plugin
export default {"row":"List_row__RNDuQ","column":"List_column__-QSrj"};